import { render } from "./VF-loading.vue?vue&type=template&id=792a2da0"
import script from "./VF-loading.vue?vue&type=script&lang=js"
export * from "./VF-loading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__